import { render, staticRenderFns } from "./QuestionPhotos.vue?vue&type=template&id=4d14b1d2&"
import script from "./QuestionPhotos.vue?vue&type=script&lang=js&"
export * from "./QuestionPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports